import { render } from "./UpdateContract.vue?vue&type=template&id=bb4acf80"
import script from "./UpdateContract.vue?vue&type=script&lang=js"
export * from "./UpdateContract.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__